/**
 * Kid-friendly loading spinner.
 *
 * Animated three-dot pulse in coral. Used anywhere we're waiting on the
 * network (LLM quiz generation, Whisper transcription, initial data fetch).
 */

interface Props {
  /** Short Arabic label shown below the dots. Optional. */
  label?: string;
  /** English subtitle. Optional. */
  labelEn?: string;
  /** Tailwind color class for the dots (default: text-coral). */
  tone?: string;
}

export function Spinner({ label, labelEn, tone = 'text-coral' }: Props) {
  return (
    <div class="flex flex-col items-center gap-2 select-none">
      <div class={`flex gap-1.5 ${tone}`} role="status" aria-label="Loading">
        <span
          class="h-3 w-3 rounded-full bg-current opacity-40"
          style={{ animation: 'huroof-pulse 1.1s ease-in-out 0s infinite' }}
        />
        <span
          class="h-3 w-3 rounded-full bg-current opacity-40"
          style={{ animation: 'huroof-pulse 1.1s ease-in-out 0.2s infinite' }}
        />
        <span
          class="h-3 w-3 rounded-full bg-current opacity-40"
          style={{ animation: 'huroof-pulse 1.1s ease-in-out 0.4s infinite' }}
        />
      </div>
      {label && <p class="text-sm font-display text-ink/60">{label}</p>}
      {labelEn && (
        <p class="text-[10px] text-ink/40" dir="ltr">
          {labelEn}
        </p>
      )}
    </div>
  );
}
